import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { CarrierFormWrapperComponent } from '../components/carrier-form-wrapper/carrier-form-wrapper.component';
import {
  CarrierFormConfig,
  CARRIER_FORM_CONFIG,
} from '../carrier.config';
import {
  resolveCarrierFormModeFromUrl,
  resolveCarrierFormTitleKey,
} from '../utils/carrier-form.util';

@Component({
  selector: 'app-carrier-form',
  standalone: true,
  imports: [CarrierFormWrapperComponent],
  templateUrl: './carrier-form.component.html',
  styleUrls: ['./carrier-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarrierFormComponent implements CanComponentDeactivate {
  private readonly router = inject(Router);
  @ViewChild('formWrapper') private readonly formWrapper?: CarrierFormWrapperComponent;

  // Determine mode from route
  mode = computed<'add' | 'edit' | 'view'>(() => {
    return resolveCarrierFormModeFromUrl(this.router.url);
  });

  // Config based on mode
  config = computed<CarrierFormConfig>(() => {
    const currentMode = this.mode();

    return {
      title: resolveCarrierFormTitleKey(currentMode),
      formFields: CARRIER_FORM_CONFIG.formFields,
      headerActions: CARRIER_FORM_CONFIG.headerActions,
      listRoute: '/configuration/carrier',
    };
  });

  // Edit mode flag
  editMode = computed(() => this.mode() === 'edit');

  // View mode flag
  viewMode = computed(() => this.mode() === 'view');

  canDeactivate(): boolean {
    return this.formWrapper?.canDeactivate() ?? true;
  }
}

